<div class="bg-gradient-primary rounded-3xl p-6 h-full min-h-[13rem] aspect-[5/4] xl:aspect-auto flex flex-col justify-between">
  <div class="flex items-center gap-2.5">
    <span class="w-10 h-10 rounded-xl bg-white flex items-center justify-center shrink-0">
      <l-icon class="text-lPrimary text-xl leading-none">{{ metric.icon }}</l-icon>
    </span>
    <p class="text-white text-base font-semibold leading-tight">{{ metric.title }}</p>
  </div>

  <div class="flex items-end gap-10 mt-6">
    <div>
      <p class="text-white/60 text-sm leading-none mb-2">Mês</p>
      <p class="text-white text-3xl font-bold leading-none">{{ metric.monthValue }}</p>
    </div>

    <div>
      <p class="text-white/60 text-sm leading-none mb-2">Ano</p>
      <p class="text-white text-3xl font-bold leading-none">{{ metric.yearValue }}</p>
    </div>
  </div>
</div>
